/** Third-party connection product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, flowEnum, id, principalKindEnum } from './_shared.js';

export const connectionEvents = {
  'connection.start_initiated': {
    schema: z.object({
      account_id: id,
      project_id: id,
      connection_kind: z.string().min(1),
      flow: flowEnum,
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.added': {
    schema: z.object({
      account_id: id,
      project_id: id,
      connection_id: id,
      connection_kind: z.string().min(1),
      flow: flowEnum,
      duration_to_complete_ms: z.number().nonnegative().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.tested': {
    schema: z.object({
      account_id: id,
      connection_kind: z.string().min(1),
      outcome: z.enum(['ok', 'failed', 'scope_insufficient']),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.removed': {
    schema: z.object({ account_id: id, connection_id: id, connection_kind: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.refresh_failed': {
    schema: z.object({ account_id: id, connection_id: id, error_class: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.metadata_refreshed': {
    schema: z.object({ account_id: id, connection_id: id, outcome: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.bound_to_project': {
    schema: z.object({ account_id: id, connection_id: id, project_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.unbound_from_project': {
    schema: z.object({ account_id: id, connection_id: id, project_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.acl_granted': {
    schema: z.object({
      account_id: id,
      connection_id: id,
      principal_kind: principalKindEnum,
      scope: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'connection.acl_revoked': {
    schema: z.object({
      account_id: id,
      connection_id: id,
      principal_kind: principalKindEnum,
      scope: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
